export const FbIcon = ({ style = {}, fill = '#FEFCF3' }) => {
  let cls1 = { fill: fill };

  return(
    <svg id="Layer_1" dataname="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={{ width: 30, ...style }}>
      <path style={cls1} d="M16.65,24V14.73h3.07c.16-1.22.31-2.4.48-3.65H16.67c0-1-.05-2,0-2.93A1.06,1.06,0,0,1,17.78,7.1c.57-.07,1.14,0,1.72-.07h.77V3.75a14.15,14.15,0,0,0-4.11,0,4.17,4.17,0,0,0-3.31,4.16c0,.83,0,1.67,0,2.52v.64H9.7v3.64h3.09V24l-.52,0H1.54C.49,24,0,23.52,0,22.45V1.58C0,.5.49,0,1.57,0H22.45C23.54,0,24,.48,24,1.58V22.45c0,1.11-.45,1.54-1.57,1.55H16.65" />
    </svg>
  )
}
